import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><div parentName="p" {...{
        "className": "mermaid"
      }}><svg parentName="div" {...{
          "aria-role-description": ["flowchart-v2"],
          "role": "graphics-document document",
          "viewBox": "-7.5 -8 816.75 195.578125",
          "style": {
            "maxWidth": "816.75px"
          },
          "xmlns": "http://www.w3.org/2000/svg",
          "width": "100%",
          "id": "mermaid-0"
        }}><style parentName="svg">{`#mermaid-0{font-family:arial,sans-serif;font-size:16px;fill:#333;}#mermaid-0 .error-icon{fill:#552222;}#mermaid-0 .error-text{fill:#552222;stroke:#552222;}#mermaid-0 .edge-thickness-normal{stroke-width:2px;}#mermaid-0 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-0 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-0 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-0 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-0 .marker{fill:#333333;stroke:#333333;}#mermaid-0 .marker.cross{stroke:#333333;}#mermaid-0 svg{font-family:arial,sans-serif;font-size:16px;}#mermaid-0 .label{font-family:arial,sans-serif;color:#333;}#mermaid-0 .cluster-label text{fill:#333;}#mermaid-0 .cluster-label span,#mermaid-0 p{color:#333;}#mermaid-0 .label text,#mermaid-0 span,#mermaid-0 p{fill:#333;color:#333;}#mermaid-0 .node rect,#mermaid-0 .node circle,#mermaid-0 .node ellipse,#mermaid-0 .node polygon,#mermaid-0 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-0 .flowchart-label text{text-anchor:middle;}#mermaid-0 .node .label{text-align:center;}#mermaid-0 .node.clickable{cursor:pointer;}#mermaid-0 .arrowheadPath{fill:#333333;}#mermaid-0 .edgePath .path{stroke:#333333;stroke-width:2.0px;}#mermaid-0 .flowchart-link{stroke:#333333;fill:none;}#mermaid-0 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-0 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-0 .labelBkg{background-color:rgba(232, 232, 232, 0.5);}#mermaid-0 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-0 .cluster text{fill:#333;}#mermaid-0 .cluster span,#mermaid-0 p{color:#333;}#mermaid-0 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:arial,sans-serif;font-size:12px;background:hsl(80, 100%, 96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-0 .flowchartTitleText{text-anchor:middle;font-size:18px;fill:#333;}#mermaid-0 :root{--mermaid-font-family:arial,sans-serif;}`}</style><g parentName="svg"><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "6",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 0 L 10 5 L 0 10 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "12",
              "markerWidth": "12",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "4.5",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-pointStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 0 5 L 10 10 L 10 0 z"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "11",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleEnd"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5",
              "refX": "-1",
              "viewBox": "0 0 10 10",
              "className": "marker flowchart",
              "id": "mermaid-0_flowchart-circleStart"
            }}><circle parentName="marker" {...{
                "style": {
                  "strokeWidth": "1",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "r": "5",
                "cy": "5",
                "cx": "5"
              }}></circle></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "12",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossEnd"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><marker parentName="g" {...{
              "orient": "auto",
              "markerHeight": "11",
              "markerWidth": "11",
              "markerUnits": "userSpaceOnUse",
              "refY": "5.2",
              "refX": "-1",
              "viewBox": "0 0 11 11",
              "className": "marker cross flowchart",
              "id": "mermaid-0_flowchart-crossStart"
            }}><path parentName="marker" {...{
                "style": {
                  "strokeWidth": "2",
                  "strokeDasharray": "1, 0"
                },
                "className": "arrowMarkerPath",
                "d": "M 1,1 l 9,9 M 10,1 l -9,9"
              }}></path></marker><g parentName="g" {...{
              "className": "root"
            }}><g parentName="g" {...{
                "className": "clusters"
              }}></g><g parentName="g" {...{
                "className": "edgePaths"
              }}></g><g parentName="g" {...{
                "className": "edgeLabels"
              }}></g><g parentName="g" {...{
                "className": "nodes"
              }}><g parentName="g" {...{
                  "transform": "translate(-7.5, -8)",
                  "className": "root"
                }}><g parentName="g" {...{
                    "className": "clusters"
                  }}><g parentName="g" {...{
                      "id": "Draft",
                      "className": "cluster default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "179.578125",
                        "width": "800.75",
                        "y": "8",
                        "x": "8",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(339.2109375, 8)",
                        "className": "cluster-label"
                      }}><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "138.328125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Proposal creation`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "edgePaths"
                  }}><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Creation LE-DraftStatus",
                      "id": "L-Creation-DraftStatus-0",
                      "d": "M160.875,97.789L165.042,97.789C169.208,97.789,177.542,97.789,184.992,97.789C192.442,97.789,199.008,97.789,202.292,97.789L205.575,97.789"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-DraftStatus LE-Edit",
                      "id": "L-DraftStatus-Edit-0",
                      "d": "M320.453,97.789L324.62,97.789C328.786,97.789,337.12,97.789,344.57,97.789C352.02,97.789,358.586,97.789,361.87,97.789L365.153,97.789"
                    }}></path><path parentName="g" {...{
                      "markerEnd": "url(#mermaid-0_flowchart-pointEnd)",
                      "style": {
                        "fill": "none"
                      },
                      "className": "edge-thickness-normal edge-pattern-solid flowchart-link LS-Edit LE-Request",
                      "id": "L-Edit-Request-0",
                      "d": "M587.422,97.789L591.589,97.789C595.755,97.789,604.089,97.789,611.539,97.789C618.989,97.789,625.555,97.789,628.839,97.789L632.122,97.789"
                    }}></path></g><g parentName="g" {...{
                    "className": "edgeLabels"
                  }}><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g><g parentName="g" {...{
                      "className": "edgeLabel"
                    }}><g parentName="g" {...{
                        "transform": "translate(0, 0)",
                        "className": "label"
                      }}><foreignObject parentName="g" {...{
                          "height": "0",
                          "width": "0"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "edgeLabel"
                            }}></span></div></foreignObject></g></g></g><g parentName="g" {...{
                    "className": "nodes"
                  }}><g parentName="g" {...{
                      "transform": "translate(96.9375, 97.7890625)",
                      "id": "flowchart-Creation-0",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "127.875",
                        "y": "-17",
                        "x": "-63.9375",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-56.4375, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "112.875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Start proposal`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(265.6640625, 97.7890625)",
                      "id": "flowchart-DraftStatus-1",
                      "className": "node default secondary CircleSize50 flowchart-label"
                    }}><circle parentName="g" {...{
                        "height": "34",
                        "width": "109.578125",
                        "r": "54.7890625",
                        "ry": "0",
                        "rx": "0",
                        "style": {}
                      }}></circle><g parentName="g" {...{
                        "transform": "translate(-47.2890625, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "94.578125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Draft status`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(478.9375, 97.7890625)",
                      "id": "flowchart-Edit-2",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "53",
                        "width": "216.96875",
                        "y": "-26.5",
                        "x": "-108.484375",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-100.984375, -19)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "38",
                          "width": "201.96875"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Edit subgraphs, lint, `}<br parentName="span"></br>{` save, and check changes`}</span></div></foreignObject></g></g><g parentName="g" {...{
                      "transform": "translate(710.5859375, 97.7890625)",
                      "id": "flowchart-Request-3",
                      "className": "node default default flowchart-label"
                    }}><rect parentName="g" {...{
                        "height": "34",
                        "width": "146.328125",
                        "y": "-17",
                        "x": "-73.1640625",
                        "ry": "0",
                        "rx": "0",
                        "style": {},
                        "className": "basic label-container"
                      }}></rect><g parentName="g" {...{
                        "transform": "translate(-65.6640625, -9.5)",
                        "style": {},
                        "className": "label"
                      }}><rect parentName="g"></rect><foreignObject parentName="g" {...{
                          "height": "19",
                          "width": "131.328125"
                        }}><div parentName="foreignObject" {...{
                            "style": {
                              "display": "inline-block",
                              "whiteSpace": "nowrap"
                            },
                            "xmlns": "http://www.w3.org/1999/xhtml"
                          }}><span parentName="div" {...{
                              "className": "nodeLabel"
                            }}>{`Request reviews`}</span></div></foreignObject></g></g></g></g></g></g></g></svg></div></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      